import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import UIButton from 'UIComponents/button/UIButton';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`UIButton`](https://private.hubteamqa.com/uicomponents-storybook/?path=/docs/uicomponents-button-uibutton--primary)
 * type component with router support.
 */
export default function UIRouterButton(props) {
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: UIButton
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);
UIRouterButton.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, clonePropTypes(UIButton));

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterButton.defaultProps = Object.assign({}, cloneDefaultProps(UIButton), {
  use: 'tertiary-light'
});